module.exports = __webpack_public_path__ + "static/media/radio_button_gray.91ad39ec.svg";